export const SITE_MAP = {
    LOAD: 'SITE_MAP_LOAD',
    SUCCESS: 'SITE_MAP_SUCCESS',
    FAIL: 'SITE_MAP_FAIL',
    LOAD_SUBTENANT: 'SUBTENANT_SITE_MAP_LOAD',
    SUCCESS_SUBTENANT: 'SUBTENANT_SITE_MAP_SUCCESS',
    FAIL_SUBTENANT: 'SUBTENANT_SITE_MAP_FAIL'
}